// Freight measurement units and conversion, shared across all web properties.
// Values are stored/exchanged in the base (imperial) unit; the UI displays and
// parses them in the user's chosen unit.

export const Units = {
  Imperial: 0,
  Metric: 1,
} as const;
export type Units = (typeof Units)[keyof typeof Units];

export const Dimension = {
  Length: 0,
  Weight: 1,
} as const;
export type Dimension = (typeof Dimension)[keyof typeof Dimension];

function factorForDimension(dimension: Dimension): number {
  switch (dimension) {
    case Dimension.Length:
      return 0.393701;
    case Dimension.Weight:
      return 2.20462;
  }
}

export function convertToUnit(
  value: number | undefined,
  units: Units,
  dimension: Dimension,
): number | undefined {
  if (value === undefined) {
    return undefined;
  }

  if (units === Units.Metric) {
    return Math.ceil(value / factorForDimension(dimension));
  }
  return Math.ceil(value);
}

export function convertFromUnit(
  value: number,
  units: Units,
  dimension: Dimension,
): number {
  if (units === Units.Metric) {
    return value * factorForDimension(dimension);
  }
  return value;
}

export function describeUnit(unit: Units, dimension: Dimension): string {
  switch (dimension) {
    case Dimension.Length:
      return unit === Units.Imperial ? "in" : "cm";
    case Dimension.Weight:
      return unit === Units.Imperial ? "lb" : "kg";
  }
}
